import React from 'react';
import { Content } from 'src/components/light/Content';
import { DashboardContainer, DashboardBigItem } from 'src/screens/Dashboard/components/DashboardComponent';

export function InvoicesIndexScreen() {
  return (
    <Content>
      <DashboardContainer title="Invoices">
        <DashboardBigItem to="/invoices/inventory-sale" title="Inventory Sale" icon="fas fa-file-invoice" />
        <DashboardBigItem to="/invoices/platform-fee" title="Platform Fee" icon="fas fa-file-invoice-dollar" />
        <DashboardBigItem to="/invoices/fbl-delivery" title="FBL Delivery" icon="fas fa-truck" />
        <DashboardBigItem to="/invoices/general-delivery" title="General Delivery" icon="fas fa-shipping-fast" />
      </DashboardContainer>
    </Content>
  );
}
